export default "__VITE_ASSET__60798985__"